<template>
    <div>
        <div class="card">
            <Toolbar class="mb-4">
                <template #start>
                    <Button label="Nuevo" icon="pi pi-plus" class="p-button-success mr-2" @click="openNew" />                    
                </template>

                <template #end>                    
                    <FileUpload mode="basic" accept="image/*" :maxFileSize="1000000" label="Importar" chooseLabel="Importar" class="mr-2 inline-block" />
                    <Button label="Exportar" icon="pi pi-upload" class="p-button-help" @click="exportCSV($event)"  />
                </template>
            </Toolbar>

            <DataTable ref="dt" :value="products" v-model:selection="selectedProducts" dataKey="id" 
                :paginator="true" :rows="10" :filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25]"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} insumos" responsiveLayout="scroll">
                <template #header>
                    <div class="table-header flex flex-column md:flex-row md:justiify-content-between">
						<h5 class="mb-2 md:m-0 p-as-md-center">Trazabilidad</h5>
						<span class="p-input-icon-left">                        
                            <i class="pi pi-search" />
                            <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                        </span>
					</div>
                </template>
                
                <Column field="name" header="Nombre" :sortable="true" style="min-width:12rem"></Column>

                <Column field="description" header="Descripción" :sortable="true" style="min-width:16rem"></Column>

                <Column field="price" header="Precio" :sortable="true" style="min-width:8rem">
                    <template #body="slotProps">
                        $ {{slotProps.data.valor}}
                    </template>
                </Column>

                <Column field="price_usd" header="Precio USD" :sortable="true" style="min-width:8rem">
                    <template #body="slotProps">
                        USD {{slotProps.data.valor_usd}}
                    </template>
                </Column>

                <Column field="unidad" header="Unidad" :sortable="true" style="min-width:6rem">
                    <template #body="slotProps">
                        <span style="text-transform: uppercase">{{formatUnity(slotProps.data.unidad)}}</span>
                    </template>
                </Column>

                <Column :exportable="false" style="min-width:8rem">
                    <template #body="slotProps">
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editProduct(slotProps.data)" />
                        <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="confirmDeleteProduct(slotProps.data)" />
                    </template>
                </Column>

            </DataTable>
        </div>

        <Dialog v-model:visible="productDialog" :style="{width: '600px'}" header="Detalles" :modal="true" class="p-fluid">            
            <div class="field">
                <label for="name">Nombre</label>
                <InputText id="name" v-model.trim="product.name" required="true" autofocus :class="{'p-invalid': submitted && !product.name}" />
                <small class="p-error" v-if="submitted && !product.name">Nombre es requerido.</small>
            </div>
            <div class="field">
                <label for="description">Descripción</label>
                <Textarea id="description" v-model="product.description" required="true" rows="3" cols="20" />
            </div>

            <div class="formgrid grid">
                <div class="field col-4">
                    <label class="mb-3" for="price">Valor</label>
                    <InputNumber id="price" v-model="product.valor" mode="currency" currency="USD" locale="en-US" />
                </div>
                <div class="field col-4">
                    <label class="mb-3" for="price">Valor USD</label>
                    <InputNumber id="price" v-model="product.valor_usd" mode="currency" currency="USD" locale="en-US" />
                </div>
                <div class="field col-4">
                    <label class="mb-3">Unidad</label>
                    <Dropdown
                          id="unidad"
                          v-model="product.unidad"
                          :options="units"
                          class="w-full"
                          optionLabel="name"
                          optionValue="id"
                          required="false"
                          autofocus
                          :class="{ 'p-invalid': submitted && !product.unidad }"
                    />
                </div>
            </div>


            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
                <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveProduct" />
            </template>
        </Dialog>


        
        <Dialog v-model:visible="deleteProductDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span v-if="product">Seguro quieres eliminar <b>{{product.name}}</b>?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false"/>
                <Button label="Sí" icon="pi pi-check" class="p-button-text" @click="deleteProduct" />
            </template>
        </Dialog>

        <Dialog v-model:visible="deleteProductsDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span v-if="product">Are you sure you want to delete the selected products?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductsDialog = false"/>
                <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedProducts" />
            </template>
        </Dialog>


	</div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import { useToast } from 'primevue/usetoast';
import ProductService from './../services/crud.service';
import CrudService from './../services/crud.service';

export default {
    data() {
        return {
          routeName: null,
          products: null,
          productDialog: false,
          show_error: false,
          deleteProductDialog: false,
          deleteProductsDialog: false,
          product: {},
          selectedProducts: null,
          filters: {},
          submitted: false,
          validationErrors: [],
          remito: null,
          fecha_remito: null,
          orden: null,
          quantity: 0,
          monedas: [
            { value: 'USD', label: "Dolar Divisa U$S" },
            { value: 'CASH', label: "Dolar Billete USD" },
            { value: 'PESOS', label: "Peso $" }
          ],
        };
      },
      created() {
        // get route name
        this.routeName = this.$route.name;
        
        //this.initFilters();
      },
      mounted() {
        CrudService.getCRUD('unidades').then((data) => (this.units = data));
        CrudService.getCRUD(this.routeName).then(
          (data) => {
            this.products = data            
        });
      },
    setup() {
        onMounted(() => {            
        })

        const toast = useToast();
        const dt = ref();
        const products = ref();
        const productDialog = ref(false);
        const deleteProductDialog = ref(false);
        const show_error = ref(false);
        const deleteProductsDialog = ref(false);
        const product = ref({});
        //const productService = ref(new ProductService());
        const selectedProducts = ref();
        const filters = ref({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        });
        const submitted = ref(false);
        
        const units = ref([
            {label: 'Kilo', value: '1'},
        ]);

        const quantity = ref();
        const remito = ref();
        const fecha_remito = ref();
        const orden = ref();
        
        const formatUnity = (value) => {
            let unit = units.value.filter((item) => item.id == value);
            if (unit.length > 0) {
                return unit[0].name;
            }
            return ''

        };
        const formatCurrency = (value) => {
            if (value.valor) {
                let currency = value.currency == 'PESOS' ? '$' : value.currency;
				return currency + " " + value.valor.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
            }
			return;
        };
        const openNew = () => {
            product.value = {};            
            submitted.value = false;
            productDialog.value = true;
        };
        const hideDialog = () => {
            productDialog.value = false;
            submitted.value = false;
        };
        const displayErrors = (errors) => {      
              for (let key in errors) {
                this.validationErrors.push({ "field": key, "message": errors[key] });
                let error = errors[key];
                this.$toast.add({
                  severity: "error",
                  summary: "Error!",
                  detail: error[0],
                  life: 3000,
                });
              }
        };
        const saveProduct = () => {
            submitted.value = true;
            if (product.value.name.trim()) {
                if (product.value.id) { 
                    CrudService.updateCRUD('trazabilidad','trazabilidad', product.value).then(                        
                        (data) => {
                            let validationErrors = [];
                            if (data.status == 400) {
                              this.displayErrors(data.data);
                            } else {
                                products.value[findIndexById(data.data.id)] = data.data;
                                toast.add({severity:'success', summary: 'Successful', detail: 'Products Deleted', life: 3000});
                            }
                        });
                } else {
                    CrudService.createCRUD('trazabilidad','trazabilidad', product.value).then((data) => {                          
                        let validationErrors = [];
                        if (data.status == 400) {
                          this.displayErrors(data.data);                          
                        } else {
                            product.value.id = createId();
                            product.value.code = createId();
                            products.value.push(data.data);
                            
                            toast.add({severity:'success', summary: 'Successful', detail: 'Products Deleted', life: 3000});
                          }
                        }
                      );                    
                }                
                productDialog.value = false;
                product.value = {};
            }            
        };
        const editProduct = (prod) => {
            product.value = {...prod};
            product.value.unidad = parseInt(product.value.unidad)
            
            productDialog.value = true;
        };
        const confirmDeleteProduct = (prod) => {
            product.value = prod;
            deleteProductDialog.value = true;
        };
        const deleteProduct = () => {
            CrudService.deleteCRUD('trazabilidad', 'trazabilidad', product.value.id).then(
                (data) => {
                    if (data.status == 'error') {
                        toast.add({severity: "error",summary: "Oopsss!",detail: data.message, life: 3000,});
                        deleteProductDialog.value = false;
                        show_error.value = true;
                    } else {
                        products.value.splice(findIndexById(data.data.id), 1);
                        show_error.value = false;
                        deleteProductDialog.value = false;
                        toast.add({severity: "success",summary: "Éxito!",detail: "Eliminado correctamente.",life: 3000,});
                    }
                }
            );
        };
        const findIndexById = (id) => {
            let index = -1;
            for (let i = 0; i < products.value.length; i++) {
                if (products.value[i].id == id) {
                    index = i;
                    break;
                }
            }

            return index;
        };
        const createId = () => {
            let id = '';
            var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            for ( var i = 0; i < 5; i++ ) {
                id += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return id;
        };
        const exportCSV = () => {
            dt.value.exportCSV();
        };
        const confirmDeleteSelected = () => {
            deleteProductsDialog.value = true;
        };
        const deleteSelectedProducts = () => {
            products.value = products.value.filter(val => !selectedProducts.value.includes(val));
            deleteProductsDialog.value = false;
            selectedProducts.value = null;
            toast.add({severity:'success', summary: 'Successful', detail: 'Products Deleted', life: 3000});
        };

        return { dt, products, productDialog, deleteProductDialog, show_error, deleteProductsDialog, product, 
            selectedProducts, filters, submitted, units, formatCurrency, openNew, hideDialog, saveProduct, editProduct,   formatUnity,  confirmDeleteProduct, deleteProduct, findIndexById, createId, exportCSV,  confirmDeleteSelected, deleteSelectedProducts,  remito, fecha_remito, orden, quantity }

    }
}
</script>

<style lang="scss" scoped>
.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}

.product-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .product-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}

.product-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}


.p-tooltip .p-tooltip-text {
     border-radius: 3px !important;
   }
  .p-tooltip.p-tooltip-right .p-tooltip-arrow {
     border-right-color: #304562 !important;
   }
  .p-tooltip.p-tooltip-left .p-tooltip-arrow {
     border-left-color: #304562 !important;
   }
  .p-tooltip.p-tooltip-top .p-tooltip-arrow {
     border-top-color: #304562 !important;
   }
 .p-tooltip.p-tooltip-bottom .p-tooltip-arrow {
     border-bottom-color: #304562 !important;
 }
  .st_bg_color { 
    padding-top: 5px;
    font-size: 1.1rem;
    height: 2.5rem;
    border: 1px solid #C80D0D;
    background-color: #EEA2A2;
    & >div i {
        color: #FF9800;
    }
  }
</style>